import { Box, ListItemIcon, ListItemText, Menu, MenuItem, makeStyles } from "@material-ui/core";
import React, { useCallback, useState } from "react";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import { useStyleDisplay } from "../../helpers/useStyleDisplay";
import { Add, MeetingRoom } from "@material-ui/icons";
import Swal from "sweetalert2";

const useStyles = makeStyles(theme => ({
    itemDD: {
        padding: ".75rem 1rem",
        backgroundColor: "#0000",
        boxShadow: "0 1px 0 0 #efefefa0",
    },
    boxAddContainer: {
        background: `url(${toAbsoluteUrl("/media/HCH/logos/logo_c.png")})`,
        backgroundSize: "auto",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        cursor: "pointer",
    },
    boxAddIcon: {
        border: "1px dotted var(--color-primary)",
    },
    menuPopup: {
        "& .MuiMenu-paper": {
            minWidth: 300,
        },
    },
}));

export default function MenuPopoverRoom({ nodes = { nodeId: 0 }, data = [], onClickMenu = () => {} }) {
    const customClass = useStyles();
    const classsDisplay = useStyleDisplay();
    const [positionPop, setPositionPop] = useState({ left: null, top: null });

    const handleClick = useCallback(
        event => {
            if (data.length < 1) {
                Swal.fire({
                    toast: true,
                    position: 'top-end',
                    timer: 2000,
                    timerProgressBar: true,
                    showConfirmButton: false,
                    titleText: "Please select building and floor.",
                    icon: "error",
                });
                return false;
            }
            setPositionPop({ left: event.clientX, top: event.clientY });
        },
        [data],
    );

    const handleClose = () => {
        setPositionPop({ left: null, top: null });
    };

    const handleSelected = (node, roomObj) => {
        onClickMenu({ node: node.nodeId, roomObj });
        setPositionPop({ left: null, top: null });
    };

    return (
        <div className="flex-grow-1">
            <Box
                onClick={handleClick}
                className={`${customClass.boxAddContainer} h-100 w-100 d-flex align-items-center justify-content-center`}>
                <div className={`d-flex align-items-center justify-content-center border-2 ${customClass.boxAddIcon}`}>
                    <Add style={{ fontSize: "calc(100% + 72px)" }} className="t-text-primary" />
                </div>
            </Box>
            <Menu
                id={"menu_" + nodes.nodeId}
                keepMounted
                open={data.length > 0 ? Boolean(positionPop.left) : false}
                onClose={handleClose}
                anchorPosition={positionPop.left ? positionPop : { left: 0, top: 0 }}
                anchorReference="anchorPosition"
                PaperProps={{
                    className: classsDisplay.classPaperListMenuRoom,
                }}
                className={customClass.menuPopup}>
                {data.map((row, idx) => (
                    <MenuItem key={"menulist_" + idx} onClick={() => handleSelected(nodes, row)}>
                        <ListItemIcon>
                            <MeetingRoom fontSize="large" />
                        </ListItemIcon>
                        <ListItemText primary={row?.name} />
                    </MenuItem>
                ))}
            </Menu>
        </div>
    );
}
